import { render, staticRenderFns } from "./GiftVendorForm.vue?vue&type=template&id=5d8c63e4&"
import script from "./GiftVendorForm.vue?vue&type=script&lang=js&"
export * from "./GiftVendorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d8c63e4')) {
      api.createRecord('5d8c63e4', component.options)
    } else {
      api.reload('5d8c63e4', component.options)
    }
    module.hot.accept("./GiftVendorForm.vue?vue&type=template&id=5d8c63e4&", function () {
      api.rerender('5d8c63e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/modules/GiftVendorForm.vue"
export default component.exports